import { RenderModeEnum } from "../../typings/spec";

import { isMiniAppLikeMode, isMobileLikeMode } from "../../util";

export function getDefaultCrosshairTriggerEventByMode(mode) {
    return mode === RenderModeEnum["desktop-browser"] || mode === RenderModeEnum["desktop-miniApp"] ? {
        click: "pointertap",
        hover: "pointermove",
        hoverOut: "pointerleave",
        clickOut: "pointerleave"
    } : isMobileLikeMode(mode) || isMiniAppLikeMode(mode) ? {
        click: "tap",
        hover: [ "pointerdown", "pointermove" ],
        hoverOut: "pointerleave",
        clickOut: "pointerleave"
    } : null;
}

export var LayoutType;

!function(LayoutType) {
    LayoutType[LayoutType.ALL = 3] = "ALL", LayoutType[LayoutType.HORIZONTAL = 2] = "HORIZONTAL", 
    LayoutType[LayoutType.VERTICAL = 1] = "VERTICAL";
}(LayoutType || (LayoutType = {}));
//# sourceMappingURL=config.js.map
